import { push } from 'redux-first-history';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { doesInclude } from '../../Util';
import * as actions from '../../actions';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/phone.svg';
import LogoutStyled from '../shared/LogoutStyled';
import MoreOptions from '../shared/MoreOptions';
import RememberMe from '../shared/RememberMe';

import './ImprivataIdManual.scss';

/**
 * ImprivataIdManual Component
 */
export class ImprivataIdManual extends Component {
  /**
   * The allowed properties for the ImprivataIdManual component
   * @param {function} verifyImprivataIdManual verify the authentication of the manual token code given
   * @param {function} retryPush retry the push notification to the enrolled imprivataId app
   * @param {bool} isLoading is something on the page loading?
   * @param {array} errorCode the error codes to be displayed
   * @param {array} availableModalities available modalities to switch to
   */
  static propTypes = {
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    capabilities: PropTypes.object,
    deviceList: PropTypes.arrayOf(PropTypes.object),
    errorCode: PropTypes.array,
    isDeviceManagementWorkflow: PropTypes.bool,
    isLoading: PropTypes.bool,
    retryPush: PropTypes.func,
    serverState: PropTypes.object,
    verifyImprivataIdManual: PropTypes.func,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };
  static defaultProps = {
    availableModalities: [],
    capabilities: {},
    deviceList: [],
    serverState: null,
    isDeviceManagementWorkflow: false,
    useCustomUX: false,
  };

  submit = data => {
    this.props.verifyImprivataIdManual(data.tokenCode);
  };
  buildCapabilityList = (capability) => {
    let capabilityList = '';
    capabilityList = capabilityList.concat(capability);
    return capabilityList;
  };

  render() {
    const {
      availableModalities,
      capabilities,
      isDeviceManagementWorkflow,
      retryPush,
      serverState,
      startDeviceManagementWorkflow,
      viewDeviceList,
      selfServiceEnabled,
      useCustomUX,
    } = this.props;

    const hasTempCodeMessage = serverState &&
      serverState.temporaryCodeAllowed &&
      !serverState.temporaryCodeAvailable;
    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'iid') : [];
    let moreOptions = (modalities.length > 0) ? <MoreOptions currentModality='iid' /> : null;
    const logoutStyle = useCustomUX ? 'black' : 'white';
    if (hasTempCodeMessage && moreOptions === null) {
      moreOptions = <div className='Temp-code-text'>Alternatively, call your help desk for a temp code</div>;
    }
    let capabilitiesToRender = '';
    // Check if Fortuna
    try {
      capabilitiesToRender = capabilities.DeviceManagement[0].functions.map(this.buildCapabilityList);
    }
    catch (error) {
      try {
        // Check if Europa
        if (capabilities.DeviceManagement.version != null) {
          capabilitiesToRender = 'enroll';
        }
      }
      catch (error) {
        capabilitiesToRender = '';
      }
    }

    if (selfServiceEnabled) {
      return (
        <div className='content-body'>
          <SingleInput
            headerImage={headerImage}
            headerTitle='Imprivata ID'
            manageDeviceLink={isDeviceManagementWorkflow || !doesInclude(capabilitiesToRender, 'list') ?
              null : viewDeviceList
            }
            enrollDeviceLink={isDeviceManagementWorkflow || !doesInclude(capabilitiesToRender, 'enroll') ?
              null : startDeviceManagementWorkflow
            }
            placeholderText='Imprivata ID token code'
            inputType='text'
            onInputChange={this.inputChange}
            submitText='Confirm your identity'
            onSubmit={this.submit}
            retryText="Didn't get a notification?"
            maxLength='6'
            onRetryClick={retryPush}
            moreOptionsLink={moreOptions}
            logoutComponent={<LogoutStyled type={logoutStyle} />}
            footer={<RememberMe />}
            useCustomUX={useCustomUX}
          />
        </div>
      );
    }
    else {
      return (
        <div className='content-body'>
          <SingleInput
            headerImage={headerImage}
            headerTitle='Imprivata ID'
            placeholderText='Imprivata ID token code'
            inputType='text'
            onInputChange={this.inputChange}
            submitText='Confirm your identity'
            onSubmit={this.submit}
            retryText="Didn't get a notification?"
            maxLength='6'
            onRetryClick={retryPush}
            moreOptionsLink={moreOptions}
            logoutComponent={<LogoutStyled type={logoutStyle} />}
            footer={<RememberMe />}
            useCustomUX={useCustomUX}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  const {
    errorCode, isLoading, availableModalities, serverState, capabilities, deviceList, isDeviceManagementWorkflow,
    selfServiceEnabled, useCustomUX, isClinicalWorkflow,
  } = state.login;
  return {
    isLoading,
    errorCode,
    availableModalities,
    serverState,
    capabilities,
    deviceList,
    isDeviceManagementWorkflow,
    selfServiceEnabled,
    useCustomUX,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifyImprivataIdManual: tokenCode => {
      dispatch(actions.verifyImprivataIdManual(tokenCode) );
    },
    retryPush: () => {
      dispatch(actions.initiateImprivataIdPush() );
    },
    viewDeviceList: () => {
      dispatch(actions.startIgnoreTimeout() );
      dispatch(push('/devicelist') );
    },
    startDeviceManagementWorkflow: () => {
      dispatch(actions.startDeviceManagementSession() );
      dispatch(actions.startIgnoreTimeout() );
      dispatch(actions.moreOptionsChooseModality(false) );
      dispatch(push('/choosemodality') );
    },
    returnToChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImprivataIdManual);
